import { useEffect } from 'react';

export default function useResetErrorsOnUnmount(resetErrors) {
  useEffect(() => {
    return () => {
      resetErrors();
    };
  }, [resetErrors]);
}
